import React, {Component} from 'react';
import ParkingSpots from './ParkingSpots';
import ParkingAreas from './ParkingAreas';
import PointsOfInterest from './PointsOfInterest';

const GeoJsonLayer = (props) => {
  const {data, entity, zoomLevel} = props;
  switch (entity) {
    case 'parkingLocations':
      return <ParkingAreas data={data} />;
    case 'pointsOfInterest':
      return <PointsOfInterest data={data} />;
    default:
      return <ParkingSpots data={data} zoomLevel={zoomLevel} />;
  }
};

export default GeoJsonLayer;



// WEBPACK FOOTER //
// ./src/containers/MapLayers/GeoJsonLayer.js